export default "__VITE_ASSET___app/immutable/assets/modal-logo-light-background.DE6anOGP.svg__"